// Organizations store — server API mirror of the old localStorage `ira_orgs`.
// System sees all (optionally by MLS); an org admin sees only their own org.
// Each org includes a server-computed `seatsUsed`.

import { api } from '../api';

export const orgStore = {
  // Public: resolve an org-scoped invite link (org name + its MLS) for the signup
  // screen, before the invitee is authenticated.
  async invite(orgId) {
    return api.get(`/api/orgs/${encodeURIComponent(orgId)}/invite`);
  },
  async list(mlsId) {
    const qs = mlsId ? `?mlsId=${encodeURIComponent(mlsId)}` : '';
    const { orgs } = await api.get(`/api/orgs${qs}`);
    return orgs;
  },

  // Admin is provisioned password-less (server emails a setup link). Returns the full
  // response so callers can surface { inviteSent, setupLink } (setupLink only in dev).
  async create({ name, mlsId, seats, trialSeats, trialDays, systemOrg, adminName, adminEmail } = {}) {
    // appOrigin lets the server build the admin's setup link against the CLIENT app
    // (the reset page lives in the SPA), not the API host — correct in dev and prod.
    const appOrigin = typeof window !== 'undefined' ? window.location.origin : undefined;
    return api.post('/api/orgs', {
      name, mlsId, seats, trialSeats, trialDays, systemOrg, adminName, adminEmail, appOrigin,
    });
  },

  // patch: org admin may set { remindersSuspended }; System may set any field.
  async update(id, patch) {
    const { org } = await api.patch(`/api/orgs/${id}`, patch);
    return org;
  },

  async remove(id) {
    return api.delete(`/api/orgs/${id}`);
  },
};
